(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/inactive-member-panel.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/inactive-member-panel.js');
'use strict';

const {
  InlineMessage
} = svs.components.tb_ui_react.inlineMessage;
const {
  memberRoles
} = svs.arena.constants;
const {
  postRequestActivationAsync
} = svs.arena.service.teamsService;
const {
  showActivationRequestSent,
  showActivationRequestError
} = svs.arena.pages.teams.dialogs;
const requestActivation = async (teamId, leader, teamName) => {
  const {
    error
  } = await postRequestActivationAsync(teamId, leader);
  if (error && error.code !== 2) {
    showActivationRequestError(teamName);
  } else {
    showActivationRequestSent(leader);
  }
};
const findLeader = members => {
  const leader = members === null || members === void 0 ? void 0 : members.find(_ref => {
    let {
      memberRole
    } = _ref;
    return memberRole === memberRoles.TEAM_LEADER;
  });
  if (leader !== null && leader !== void 0 && leader.firstName) {
    return leader && "".concat(leader.firstName, " ").concat(leader.lastName);
  }
};
const InactiveMemberPanel = _ref2 => {
  var _ReactRedux$useSelect;
  let {
    teamId,
    teamName
  } = _ref2;
  const members = (_ReactRedux$useSelect = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.teamDetails;
  })) === null || _ReactRedux$useSelect === void 0 || (_ReactRedux$useSelect = _ReactRedux$useSelect.find(_ref3 => {
    let {
      syndicateId
    } = _ref3;
    return teamId === syndicateId;
  })) === null || _ReactRedux$useSelect === void 0 ? void 0 : _ReactRedux$useSelect.members;


  const leader = findLeader(members) || 'lagledaren';
  return React.createElement(InlineMessage, {
    actions: [{
      handleClick: () => {
        requestActivation(teamId, leader, teamName);
      },
      text: 'Be om aktivering'
    }],
    icon: "rest",
    isError: false
  }, "Du \xE4r vilande i laget. F\xF6r att vara med och spela beh\xF6ver du bli aktiverad av lagledaren.");
};
svs.arena.pages.teams.components.InactiveMemberPanel = InactiveMemberPanel;

 })(window);